import { isGranted } from "./isGranted/isGranted";
import { PageNotFound } from "../pages";

const RouteAccess = (Component: React.ElementType, roles: Array<string>) => {
    return isGranted(roles) ? <Component /> : <PageNotFound />
}

export default RouteAccess;